<template>
  <div class="contact">
    <h3 class="title">My {{ contact.assigment }}</h3>
    <div class="contact-info">
      <app-image class="photo" :imageUrl="contact.photo"></app-image>
      <div>
        <p class="name">{{ contact.name }}</p>
        <span class="position">{{ userType() }}</span>
      </div>
    </div>
    <div class="links">
      <a v-if="contact.phone" @click.stop="{}" :href="'sms:' + contact.phone"
        class="link-item"
        ><span class="dbc-icon dbc-icon-message"></span>Text</a
      >
      <a v-if="contact.phone" @click.stop="{}" :href="phone"
        class="link-item"
        ><span class="dbc-icon dbc-icon-phone-call"></span>Call</a
      >
      <a v-if="contact.email" @click.stop="{}" :href="email"
        class="link-item"
        ><span class="dbc-icon dbc-icon-email"></span>Email</a
      >
      <a href="#" @click.prevent="addToPhone" class="link-item"
        ><span class="dbc-icon dbc-icon-smartphone-download"></span>Add to
        phone</a
      >
      <a href="about" class="link-item"
        ><span class="dbc-icon dbc-icon-businessman"></span>About me</a
      >
      <a v-if="contact.reviewsUrl" :href="contact.reviewsUrl" class="link-item"
        ><span class="dbc-icon dbc-icon-star"></span>Reviews</a
      >
      <a v-if="contact.blogUrl" :href="contact.blogUrl" class="link-item"
        ><span class="dbc-icon dbc-icon-article"></span>Blog</a
      >
      <a href="recommendfriend" class="link-item"
        ><span class="dbc-icon dbc-icon-users-three"></span>Refer</a
      >
    </div>
  </div>
</template>

<script>
import { USER_TYPES } from '../../shared/enums/user.types'
import ImageCpmponent from '../image.vue'
import config from '../../../config/customer.api'
import { downloadVCF } from '../../helpers/vcf.helper'
export default {
  props: {
    contact: {
      required: true,
      type: Object
    },
    isDemo: {
      type: Boolean
    }
  },
  components: {
    'app-image': ImageCpmponent
  },
  computed: {
    email () {
      return this.isDemo ? '#' : 'mailto:' + this.contact.email
    },
    phone () {
      return this.isDemo ? '#' : 'tel:' + this.contact.phone
    }
  },
  methods: {
    addToPhone () {
      const url = config.downloadVCF + '/' + this.contact.id
      downloadVCF(url, this.$store.state.standalone.isStandalone)
    },
    userType () {
      // Salesperson must be renamed to "Customer Experience Advisor"
      return this.contact.userType === USER_TYPES.Salesperson
        ? 'Customer Experience Advisor'
        : Object.entries(USER_TYPES).find(
            ([key, val]) => val === this.contact.userType
          )[0]
    }
  }
}
</script>

<style scoped>
.contact {
  border-bottom: 1px solid #ccc;
  margin-bottom: 24px;
  padding-bottom: 15px;
}
.contact:last-child {
  margin-bottom: 0;
  border-bottom: none;
}
.contact-info {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.photo {
  max-width: 60px;
  max-height: 60px;
  border-radius: 50%;
  margin-right: 15px;
}
.name {
  font-weight: 600;
  font-size: 1.2em;
  margin: 0;
  padding: 0;
}
.links {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.link-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-transform: uppercase;
  text-align: center;
  line-height: 1;
  font-size: 0.8em;
  padding: 10px;
  margin: 0 auto;
  color: #2C61D5;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.link-item:hover {
  background-color: #eee;
}
.link-item > span {
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// contact.component.vue?7d71561c